import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';

import '../node_modules/swiper/dist/css/swiper.css';

import '../node_modules/odometer/themes/odometer-theme-minimal.css';

var layouts = {

  "_default": function _default() {
    return import('../layouts/default.vue' /* webpackChunkName: "layouts/default" */).then(function (m) {
      return m.default || m;
    });
  }

};

var resolvedLayouts = {};

export default {
  head: { "title": "Кондитерские изделия Морозова", "meta": [{ "charset": "utf-8" }, { "name": "viewport", "content": "width=device-width, initial-scale=1, user-scalable=no" }, { "name": "msapplication-TileColor", "content": "#b91d47" }, { "name": "theme-color", "content": "#ffffff" }], "link": [{ "rel": "shortcut icon", "type": 'image/x-icon', "href": '/favicon.ico' }, { "rel": "apple-touch-icon", "sizes": "180x180", "href": '/apple-touch-icon.png' }, { "rel": "icon", "type": 'image/png', "sizes": "32x32", "href": '/favicon-32x32.png' }, { "rel": "manifest", "href": '/site.webmanifest' }, { "rel": "mask-icon", "href": '/safari-pinned-tab.svg', "color": "#b91d47" }], "style": [], "script": [] },
  render: function render(h, props) {

    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);

    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [templateEl]);

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [transitionEl]);
  },

  data: function data() {
    return {
      layout: null,
      layoutName: ''
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this;
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this;
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
  },


  methods: {
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default';
      this.layoutName = layout;
      var _layout = '_' + layout;
      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this = this;

      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default';
      var _layout = '_' + layout;
      if (resolvedLayouts[_layout]) {
        return _Promise.resolve(resolvedLayouts[_layout]);
      }
      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this.$nuxt) {
          return _this.$nuxt.error({ statusCode: 500, message: e.message });
        }
      });
    }
  },
  components: {}
};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/App.js
// module id = ./.nuxt/App.js
// module chunks = 5